/**
 * 行为统计工具模块
 * 实现用户行为数据的收集和上报功能
 */

const UID_KEY = "ai_kf_bd_uid_1";
const STAT_ENDPOINT = "//click.fhd001.com/click";
const PROJECT_ID = "fhdportal_saas_fxg";

/**
 * 获取或生成用户唯一标识ID
 * 如果localStorage中不存在，则生成一个新的8位随机数字ID
 * @returns 用户唯一标识ID
 */
export function getUid(): string {
  try {
    let uid = localStorage.getItem(UID_KEY);
    if (!uid) {
      // 生成8位随机数字（10000000-99999999）
      uid = Math.floor(10000000 + Math.random() * 90000000).toString();
      localStorage.setItem(UID_KEY, uid);
    }
    return uid;
  } catch (e) {
    // localStorage不可用时，生成临时ID
    console.warn("localStorage不可用，使用临时UID", e);
    return Math.floor(10000000 + Math.random() * 90000000).toString();
  }
}

/**
 * 发送行为统计数据
 * 通过Image对象发送GET请求，避免跨域问题
 * @param modal - 模块名称（可选）
 * @param fid - 功能ID（可选）
 * @param params - 额外参数（可选）
 */
export function statSend(modal?: string, fid?: string, params?: string): void {
  try {
    const timestamp = new Date().getTime();
    const uid = getUid();
    const path = encodeURIComponent(window.location.href);
    const encodedParams = encodeURIComponent(params || "");

    // 构建统计请求URL
    const imgSrc = `${STAT_ENDPOINT}?m=c&pid=${PROJECT_ID}&fid=${fid || ""}&uid=${uid}&path=${path}&params=${encodedParams}&bi=true&ip=0.0.0.0&_=${timestamp}`;

    // 使用Image对象发送请求，避免跨域问题
    new Image().src = imgSrc;
  } catch (e) {
    console.error("统计点击失败:", e);
  }
}

/**
 * 统计按钮点击事件
 * @param buttonName - 按钮名称
 * @param additionalParams - 额外参数（可选）
 */
export function trackButtonClick(
  buttonName: string,
  additionalParams?: string,
): void {
  statSend("button", buttonName, additionalParams);
}

/**
 * 统计页面访问
 * @param pageName - 页面名称
 */
export function trackPageView(pageName: string): void {
  statSend("page", pageName);
}
